module.exports = __webpack_public_path__ + "img/33.b9fd5aba.png";